module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "video-small-thumbnail-base.38772648.png";